import {of as observableOf,  Observable, BehaviorSubject, of } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';
import { UtilService } from './util.service';
import { HttpClient } from '@angular/common/http';
import { FSAppsService } from './fsapps.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthenticationService {
  private endpoint = environment.apiUrl;
  user = new BehaviorSubject<any>(null);

  constructor(
    private http: HttpClient,
    public util: UtilService,
    public fsAppsService: FSAppsService,
    private router: Router,
  ) {}

  /**
   * Get the authenticated user.
   * @returns      User, if user exists
   */
  getAuthenticatedUser(doLogin = false) {
    const user = this.getUser();

    if (doLogin) {
      return this.isAuthenticated().pipe(map(
        (result: any) => {
          if (result) {
            this.setUser(result);
            return this.getUser();
          } else {
            this.removeUser();
          }
        },
        (e: any) => {
          this.removeUser();
          console.error(e);
        }
      ));
    } else if (user) {
        return observableOf(user);
    } else {
      return observableOf(null); // no user but don't login
    }
  }

  /**
   * Check if user is admin.
   */
  isAdmin() {
    return this.user.getValue().role === 'admin';
  }

  /**
   * Check if user is authenticated
   */
  isAuthenticated() {
    return this.http.get(this.endpoint + 'auth/user', { withCredentials: true }).pipe(catchError(this.util.handleError));
  }

  userHasPrivilege(privilege: string) {
    return this.http.get<boolean>(environment.apiUrl + `auth/has-privilege/${privilege}`, { withCredentials: true });
  }

  checkIfAdminAccess(user) {
    if (user.roles.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  checkIfSupportUser(user) {
    return user.isSupportUser;
  }

  checkIfUserManagementAccess(user) {
    // return false;
    if (user.roles.some(x => { return x.hierarchy_level <= 3 })) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Return user if user is set, or try to get user from local storage
   */
  getUser() {
    if (this.user.getValue()) {
      return this.user.getValue();
    } else {
      // check local storage
      try {
        this.user.next(JSON.parse(localStorage.getItem('user')));
        return this.user.getValue();
      } catch (e) {
        return null;
      }
    }
  }

  /**
   * Set the user to current scope and local storage.
   */
  setUser(user) {
    this.user.next(user);
    localStorage.setItem('user', JSON.stringify(user));
  }

  /**
   * Remove user from scope and local storage.
   */
  removeUser() {
    this.user.next(null);
    localStorage.removeItem('user');
  }
    /**
   *
   * Redirect user
   */
  login() {
    const requestingUrl = window.location.pathname;
    localStorage.setItem('requestingUrl', requestingUrl);
    this.fsAppsService.login().subscribe((result: any) => {
        this.util.navigateExternal(result.url);
    });
  }

    /**
   * Logout user and redirect to homepage.
   * Remove local storage items.
   */
  logout() {

    return this.http.get(this.endpoint + 'auth/logout', { withCredentials: true }).pipe(map(result  => {
      localStorage.removeItem('requestingUrl');
      localStorage.removeItem('user');
      this.removeUser();
      this.router.navigate(['/']);
    }),
     catchError(this.util.handleError)
    );

  }
}
